// extracted by mini-css-extract-plugin
export default {"wrapper":"lyRopK","category":"IxNiF6","search":"cY86qS","searchBox":"XCFBxE","magnifyingGlassIcon":"oxyE22"};